<ng-container *transloco="let t">
  <bgo-calculator-navbar>
    <p class="ml-sm text-base">
      {{ t('calculators.navbar.inPartnership') }}
      <a target="_blank" [href]="partnerLink">
        <img [src]="logo" alt="Erneuerbarheizen" class="h-5" />
      </a>
    </p>
  </bgo-calculator-navbar>
  <div class="mt-2xl h-layout">
    <p class="block text-base md:hidden">
      {{ t('calculators.navbar.inPartnership') }}
      <a target="_blank" [href]="partnerLink">
        <img [src]="logo" alt="Erneuerbarheizen" class="h-5" />
      </a>
    </p>
  </div>
  <iframe
    [src]="'https://hcalc.ch/#/' + calculatorsService.erneuerbarheizenLanguage | safe"
    class="mt-lg h-260 min-h-screen w-full py-md sm:py-0 lg:mt-2xl"
  ></iframe>
</ng-container>
